/**
 * Utilidad para detectar dispositivos móviles
 */

/**
 * Detecta si el dispositivo actual es móvil
 * @returns {boolean} true si es dispositivo móvil, false si no
 */
export const isMobileDevice = () => {
  // Verificar por user agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Patrones comunes de dispositivos móviles
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // Verificar por tamaño de pantalla (ancho menor a 768px se considera móvil)
  const isMobileScreen = window.innerWidth < 768;
  
  // Verificar por touch capability
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return mobileRegex.test(userAgent) || (isMobileScreen && isTouchDevice);
};

/**
 * Recarga la página de forma segura
 */
export const reloadPage = () => {
  window.location.reload();
};

/**
 * Recarga la página solo si es dispositivo móvil
 */
export const reloadPageOnMobile = () => {
  if (isMobileDevice()) {
    // Pequeño delay para asegurar que la navegación se complete
    setTimeout(() => {
      reloadPage();
    }, 100);
  }
};

